import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';

import { SharedModule } from '../shared/shared.module';
import { PaylocRoutingModule } from './payloc-routing.module';

import { PaylocComponent } from './payloc.component';
import { PaylocListComponent } from './payloc-list/payloc-list.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { PaylocMenuComponent } from './payloc-menu/payloc-menu.component';

import { PaylocRightNavComponent } from './payloc-right-nav/payloc-right-nav.component';
import { SelectCustomerModalComponent } from './select-customer-modal/select-customer-modal.component';
import { HomeComponent } from "./home/home.component";
import { SubpaymentFormComponent } from './subpayment-form/subpayment-form.component';
import { CoreModule } from '../core/core.module';
import { CustomerFormComponent } from '../customer/customer-form/customer-form.component';


@NgModule({
  imports: [
    SharedModule,
    PaylocRoutingModule,
    NgbModule.forRoot(),
    CoreModule
  ],
  declarations: [
    PaylocComponent,
    PaylocListComponent,
    PaylocMenuComponent,
    PaylocRightNavComponent,
    SelectCustomerModalComponent,
    HomeComponent,
    SubpaymentFormComponent,
    CustomerFormComponent,
  ],
  exports: [
    PaylocComponent,
    PaylocListComponent,
    PaylocMenuComponent,
    PaylocRightNavComponent,
    HomeComponent,
    SelectCustomerModalComponent,
    SubpaymentFormComponent,
    CustomerFormComponent
  ],
  entryComponents: [
    PaylocMenuComponent,
    SelectCustomerModalComponent
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class PaylocModule { }
